import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  RateUsageAnalyticsRequestDto,
  RateUsageAnalyticsResponseDto,
} from "../../../api/apiServices/audit/controllers/rateUsage/rateUsage.requestsDto";

const initialState: {
  loading: boolean;
  allTimeLoading: boolean;
  data?: RateUsageAnalyticsResponseDto;
  allTimeData?: RateUsageAnalyticsResponseDto;
} = {
  loading: false,
  allTimeLoading: false,
};

const rateUsageAnalyticsSlice = createSlice({
  name: "rateUsageAnalytics",
  initialState,
  reducers: {
    loadAnalytics(state, _action: PayloadAction<RateUsageAnalyticsRequestDto>) {
      state.loading = true;
    },
    loadAnalyticsSuccess(state, action: PayloadAction<RateUsageAnalyticsResponseDto>) {
      state.loading = false;
      state.data = action.payload;
    },
    loadAnalyticsReject(state) {
      state.loading = false;
    },
    loadAllTimeAnalytics(state, _action: PayloadAction<RateUsageAnalyticsRequestDto>) {
      state.allTimeLoading = true;
    },
    loadAllTimeAnalyticsSuccess(state, action: PayloadAction<RateUsageAnalyticsResponseDto>) {
      state.allTimeLoading = false;
      state.allTimeData = action.payload;
    },
    loadAllTimeAnalyticsReject(state) {
      state.allTimeLoading = false;
    },
  },
});

export default rateUsageAnalyticsSlice;
